import { useState, useEffect, useRef, useCallback } from "react";
import { Bell } from "lucide-react";
import api from "../../services/api";
import NotificationPanel from "./NotificationPanel";

const POLL_INTERVAL = 60_000; // 60 secondes

export default function NotificationBell({ onNavigate }) {
  const [open, setOpen]       = useState(false);
  const [count, setCount]     = useState(0);
  const intervalRef           = useRef(null);

  const fetchCount = useCallback(async () => {
    try {
      const { count: c } = await api.notifications.unreadCount();
      setCount(c || 0);
    } catch {}
  }, []);

  useEffect(() => {
    fetchCount();
    intervalRef.current = setInterval(fetchCount, POLL_INTERVAL);
    return () => clearInterval(intervalRef.current);
  }, [fetchCount]);

  return (
    <>
      {/* Cloche */}
      <div style={{ position: "relative", flexShrink: 0 }}>
        <button
          onClick={() => setOpen(o => !o)}
          aria-label={`Notifications${count > 0 ? ` (${count} non lues)` : ''}`}
          style={{
            width: 34, height: 34,
            border: "var(--border)", borderRadius: 8,
            display: "flex", alignItems: "center", justifyContent: "center",
            background: open ? "var(--bg-secondary)" : "var(--bg-secondary)",
            color: "var(--text-secondary)",
            cursor: "pointer",
            position: "relative",
          }}
        >
          <Bell size={16} />

          {/* Badge rouge */}
          {count > 0 && (
            <div style={{
              position: "absolute", top: -4, right: -4,
              minWidth: 16, height: 16,
              background: "#dc2626", color: "#fff",
              borderRadius: 8, fontSize: 10, fontWeight: 700,
              display: "flex", alignItems: "center", justifyContent: "center",
              padding: "0 3px",
              border: "2px solid var(--bg-card)",
              lineHeight: 1,
            }}>
              {count > 99 ? "99+" : count}
            </div>
          )}
        </button>
      </div>

      {/* Panneau */}
      {open && (
        <NotificationPanel
          onClose={() => setOpen(false)}
          onNavigate={onNavigate}
          onUnreadChange={setCount}
        />
      )}
    </>
  );
}
